import type { SendReportRequest, SendReportResult } from '@brainkey/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';

import { toast } from '../../components/ui/Toast';
import { deliveryApi } from '../api/endpoints';
import { queryKeys } from '../queryClient';

export interface SendReportVariables {
  reportId: string;
  body: SendReportRequest;
}

/** Takes `clientId` so a successful send/resend can invalidate that client's timeline. */
export function useSendReport(
  clientId: string,
): UseMutationResult<SendReportResult, unknown, SendReportVariables> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId, body }: SendReportVariables) => deliveryApi.sendReport(reportId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.clients.timeline(clientId) });
      toast.success('Report sent');
    },
  });
}

export function useResendReport(
  clientId: string,
): UseMutationResult<SendReportResult, unknown, SendReportVariables> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId, body }: SendReportVariables) =>
      deliveryApi.resendReport(reportId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.clients.timeline(clientId) });
      toast.success('Report resent');
    },
  });
}
